import { Trans } from 'react-i18next';
import { Box, Link } from '@resideo/blueprint-react';
import React from 'react';
import styled from 'styled-components';
import { createMessageHandler } from '../../../utils/createMessageHandler';

const UserTerms = styled(Box)`
  line-height: 28px;
`;

const NewTermsAndPerksLinks = ({ proTermsUrl, perkTermsUrl }) => {
  const messageHandler = createMessageHandler();

  return (
    <UserTerms>
      <Trans
        i18nKey={'signUp.newTermsCheckBoxText'}
        components={[
          <Link
            key={0}
            data-test-new-terms-link
            href={!messageHandler.hasMessageHandler ? proTermsUrl : '#'}
            target='_blank'
            onClick={e => {
              if (messageHandler.hasMessageHandler) {
                e.preventDefault();
                // Signal mobile app to open link in external browser
                postMessage('openExternalUrl', proTermsUrl);
              }
            }}
          />,
          <Link
            key={1}
            data-test-perks-link
            href={!messageHandler.hasMessageHandler ? perkTermsUrl : '#'}
            target='_blank'
            onClick={e => {
              if (messageHandler.hasMessageHandler) {
                e.preventDefault();
                // Signal mobile app to open link in external browser
                postMessage('openExternalUrl', perkTermsUrl);
              }
            }}></Link>,
        ]}
      />
    </UserTerms>
  );
};

export default NewTermsAndPerksLinks;
